import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Panel } from '@/components/Panel';

export default function Updates() {
  const [items, setItems] = useState([]);
  useEffect(() => { (async () => { const { data } = await api.get('/founders/updates'); setItems(data.updates || []); })(); }, []);
  return (
    <div className="space-y-6">
      <Panel className="p-8">
        <div className="h-eyebrow">Founder Updates</div>
        <div className="h-display text-4xl mt-1" style={{ color: 'var(--heritage-plum)' }}>From the atelier</div>
      </Panel>

      <div className="grid md:grid-cols-2 gap-6">
        {items.map(u => (
          <Panel key={u.id} className="p-3 overflow-hidden">
            {(u.image_url || u.image_base64) && (
              <img src={u.image_url || (u.image_base64?.startsWith('data:') ? u.image_base64 : `data:image/png;base64,${u.image_base64}`)}
                   alt={u.title} className="w-full h-56 object-cover rounded-lg" />
            )}
            <div className="p-5">
              <div className="h-eyebrow">{(u.created_at || '').slice(0, 10)}</div>
              <div className="h-serif text-2xl mt-1" style={{ color: 'var(--heritage-plum)' }}>{u.title}</div>
              <p className="text-sm mt-2 opacity-85" style={{ color: 'var(--heritage-plum)' }}>{u.body}</p>
            </div>
          </Panel>
        ))}
        {items.length === 0 && (
          <div className="text-sm opacity-70" style={{ color: 'var(--heritage-plum)' }}>No updates yet.</div>
        )}
      </div>
    </div>
  );
}
